export class ColorsConstants {
  public static defaultChartBackGroundColor = 'rgba(255, 164, 182, 0.734)';
  public static FEMALE_COLOR = '#d5a6bd';
  public static MALE_COLOR = '#6fa8dc';
  public static TOTAL_COLOR = '#26A2ED';
  public static SUCCESS_COLOR = '#40BFB4';
  public static FAIL_COLOR = 'rgb(255, 203, 212)';
  public static SUCCESS_COLOR_OPACITY = '#40bfb469';
  public static TOTAL_COLOR_OPACITY = '#26a1ed75';
  public static FAIL_COLOR_OPACITY = 'rgba(255, 203, 212, 0.651)';
  public static PRIMARY_COLOR = '#40BFB4';
  public static LIGHT_COLOR = 'white';
  public static WARN_RED_COLOR = '#e6002a';
  public static BLUE_COLOR = '#293AD2';
  public static LIGHT_BLUE_COLOR = '#293AD230';
  public static RED_COLOR = '#e14b4b';
  public static LIGHT_RED_COLOR = '#e14b4b30 ';
  public static WARN_ORANGE_COLOR = '#F1A696';
  public static AZURE_COLOR = '#5AE9F0';
  public static YELLOW_COLOR = '#F1DE43';
  public static PURPLE_COLOR = '#C443F1';
  public static SURFACE_DARK = '#f4f4f4';
  public static TRANSPARENT = 'transparent';
  public static PRIMARY_DARK_COLOR = '#008C8D';
  public static LIGHT_GREY_COLOR = '#CCCCCC';
  public static GREY_COLOR = '#554f4d';
}
export class BaseColorsConstants implements ThemeColors {
  public defaultChartBackGroundColor = 'rgba(255, 164, 182, 0.734)';
  public FEMALE_COLOR = '#d5a6bd';
  public MALE_COLOR = '#6fa8dc';
  public TOTAL_COLOR = '#26A2ED';
  public SUCCESS_COLOR = '#40BFB4';
  public FAIL_COLOR = 'rgb(255, 203, 212)';
  public SUCCESS_COLOR_OPACITY = '#40bfb469';
  public TOTAL_COLOR_OPACITY = '#26a1ed75';
  public FAIL_COLOR_OPACITY = 'rgba(255, 203, 212, 0.651)';
  public PRIMARY_COLOR = '#006387';
  public LIGHT_COLOR = 'white';
  public WARN_RED_COLOR = '#e6002a';
  public BLUE_COLOR = '#0052B4';
  public LIGHT_BLUE_COLOR = '#293AD230';
  public RED_COLOR = '#e14b4b';
  public LIGHT_RED_COLOR = '#e14b4b30 ';
  public WARN_ORANGE_COLOR = '#F1A696';
  public AZURE_COLOR = '#5AE9F0';
  public YELLOW_COLOR = '#F1DE43';
  public PURPLE_COLOR = '#C443F1';
  public SURFACE_DARK = '#f4f4f4';
  public TRANSPARENT = 'transparent';
  public PRIMARY_DARK_COLOR = '#008C8D';
  public LIGHT_GREY_COLOR = '#CCCCCC';
  public GREY_COLOR = '#554f4d';
  public GREY_600_COLOR = '#6C757D';
  public ORANGE_COLOR = '#FFA800';
  public ORANGE_COLOR_OPACITY_20 = 'rgba(249,199,79 , 0.2)';
  public PRIMARY_COLOR_OPACITY_20 = 'rgba(63,190,177 , 0.2)';
  public BLUE_COLOR_OPACITY_20 = 'rgba(0,82,180,0.2)';
  public GREY_COLOR_700 = '#495057';
  public GREY_COLOR_400 = '#CED4DA';
  public SECONDARY_COLOR = '#3FBEB1';
}

export class ModdakirColorConstants extends BaseColorsConstants implements ThemeColors {}

export class TaalamColorConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#D5BA8C';
}

export class RattelColorConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#12925F';
}

export class BredaColorConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#3B88BC';
}

export class TeganColorConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#B5944D';
}

export class ModdakirKidsConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#8566FF';
}

export class TebyanColorConstants extends BaseColorsConstants implements ThemeColors {
  public override PRIMARY_COLOR = '#93843F';
}

export interface ThemeColors {
  defaultChartBackGroundColor: string;
  FEMALE_COLOR: string;
  MALE_COLOR: string;
  TOTAL_COLOR: string;
  SUCCESS_COLOR: string;
  FAIL_COLOR: string;
  SUCCESS_COLOR_OPACITY: string;
  TOTAL_COLOR_OPACITY: string;
  FAIL_COLOR_OPACITY: string;
  PRIMARY_COLOR: string;
  LIGHT_COLOR: string;
  WARN_RED_COLOR: string;
  BLUE_COLOR: string;
  LIGHT_BLUE_COLOR: string;
  RED_COLOR: string;
  LIGHT_RED_COLOR: string;
  WARN_ORANGE_COLOR: string;
  AZURE_COLOR: string;
  YELLOW_COLOR: string;
  PURPLE_COLOR: string;
  SURFACE_DARK: string;
  TRANSPARENT: string;
  PRIMARY_DARK_COLOR: string;
  LIGHT_GREY_COLOR: string;
  GREY_COLOR: string;
  GREY_600_COLOR: string;
  ORANGE_COLOR: string;
  ORANGE_COLOR_OPACITY_20: string;
  PRIMARY_COLOR_OPACITY_20: string;
  BLUE_COLOR_OPACITY_20: string;
  GREY_COLOR_700: string;
  GREY_COLOR_400: string;
  SECONDARY_COLOR: string;
}
